import { render } from "./ModalChoiceNotifyComponent.vue?vue&type=template&id=b18b92f8&scoped=true"
import script from "./ModalChoiceNotifyComponent.vue?vue&type=script&lang=js"
export * from "./ModalChoiceNotifyComponent.vue?vue&type=script&lang=js"

import "./ModalChoiceNotifyComponent.vue?vue&type=style&index=0&id=b18b92f8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b18b92f8"]])

export default __exports__